<template>
  <div class="row">
    <div class="col-8 pl-1">
      <b-form-group
        label="Aduana coordinadora"
      >
        <v-select
          v-model="serverConfig.gestoraId"
          :options="customsCompanies"
          name="managingCustoms"
          @input="onServerChange"
          :reduce="option => option.value"
        >
          <span slot="no-options">
            No hay coincidencias
          </span>
        </v-select>
      </b-form-group>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';

import { FILTER_SERVER_MAPPER_DASHBOARD } from '@/febos/aduanas/dashboard/views/components/config';
import { ioGetHoldingCompanies } from '@/febos/servicios/api/v2.companies.api';

export default {
  components: {},
  props: {
    periodos: {
      type: Array,
      required: false
    },
    hasQueryFilters: {
      type: Boolean,
      default: false
    },
    clearQueryFilters: {
      type: Function
    }
  },
  data() {
    return {
      customsCompanies: [],
      onTheFlyConfig: {
        name: ''
      },
      serverConfig: {
        gestoraId: ''
      }
    };
  },
  watch: {

  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapState('Personalizacion', {
      colores: (state) => state.colores
    })
  },
  methods: {
    onServerChange() {
      const filters = Object.entries(this.serverConfig)
        .filter(([, value]) => !!value)
        .map(([key, value]) => (
          `${FILTER_SERVER_MAPPER_DASHBOARD[key]}:${value}`
        ))
        .join('|');
      this.$emit('on-server-filters-change', filters);
    }
  },
  async created() {
    this.customsCompanies = [];
    const response = await ioGetHoldingCompanies(
      {
        empresaId: this.company.id,
        params: {
          filtros: 'esGestoria:Y'
        }
      }
    );
    this.customsCompanies = response.data.empresas
      .map((company) => ({ value: company.empresaId, label: company.razonSocial }));
  }
};

</script>
<style>
.input-date {
  border: 1px solid #bcbcbc;
  padding: 6px 8px;
  border-radius: 5px;
}

.scroll-options {
  max-height: 400px;
  overflow-y: scroll;
}
</style>
